import React from 'react';
import confetti from 'canvas-confetti';
import { motion } from 'framer-motion';

// ── THEME ────────────────────────────────────────────────────
export const T = {
  // NeevStar brand colours — navy + gold
  blue:'#0066FF', orange:'#FF6B00', green:'#00C851',
  purple:'#7B5EA7', red:'#FF2D55', teal:'#00BCD4',
  pink:'#FF4081', yellow:'#FFD700', dark:'#1A1A2E',
  cream:'#F4F6FF', white:'#FFFFFF',
  navy:'#0D1B4B', gold:'#FFD700',
  lBlue:'#E8EEFF', lGreen:'#E0FAE8', lOrange:'#FFF3E0',
  lPurple:'#F0EEFF', lRed:'#FFE8EC', lTeal:'#E0F7FA',
  lPink:'#FFE4EF', lYellow:'#FFFDE7',
  grad1:`linear-gradient(135deg,#FFD700,#FF9500)`,
  grad2:`linear-gradient(135deg,#7B5EA7,#B44FFF)`,
  grad3:`linear-gradient(135deg,#00C851,#00E676)`,
  grad4:`linear-gradient(135deg,#7B5EA7,#FFD700)`,
  grad5:`linear-gradient(135deg,#0D1B4B,#1A3A8F)`,
  grad6:`linear-gradient(135deg,#FF4081,#FF80AB)`,
  gradHeader:`linear-gradient(135deg,#0D1B4B 0%,#1A3A8F 100%)`,
};

// ── STYLES ───────────────────────────────────────────────────
export const S={
  app:{minHeight:'100vh',background:'#F4F6FF',fontFamily:"'Nunito',sans-serif",maxWidth:'430px',margin:'0 auto',position:'relative'},
  screen:{minHeight:'100vh',paddingBottom:'85px'},
  header:{background:T.gradHeader,padding:'20px 20px 28px',borderRadius:'0 0 28px 28px',boxShadow:'0 4px 20px rgba(13,27,75,0.4)'},
  headerTop:{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'14px'},
  appName:{fontSize:'24px',fontWeight:'900',color:'white',margin:0,letterSpacing:'-0.5px'},
  streakBadge:{background:T.orange,borderRadius:'20px',padding:'6px 14px',fontSize:'14px',fontWeight:'800',color:'white',boxShadow:'0 2px 8px rgba(255,107,0,0.4)'},
  greetCard:{background:'rgba(255,255,255,0.18)',borderRadius:'16px',padding:'14px',display:'flex',alignItems:'center',gap:'12px',backdropFilter:'blur(10px)'},
  charImg:{width:'50px',height:'50px',borderRadius:'50%',objectFit:'cover',border:'2px solid rgba(255,255,255,0.5)'},
  gTitle:{fontSize:'15px',fontWeight:'800',color:'white',margin:'0 0 3px'},
  gSub:{fontSize:'12px',color:'rgba(255,255,255,0.9)',margin:0},
  xpRow:{display:'flex',alignItems:'center',gap:'8px',marginTop:'12px'},
  xpLabel:{fontSize:'12px',color:'rgba(255,255,255,0.9)',fontWeight:'700',whiteSpace:'nowrap'},
  xpTrack:{flex:1,background:'rgba(255,255,255,0.25)',borderRadius:'10px',height:'10px',overflow:'hidden'},
  xpFill:{height:'100%',background:T.yellow,borderRadius:'10px',boxShadow:'0 0 8px rgba(255,214,0,0.6)'},
  xpVal:{fontSize:'12px',color:T.yellow,fontWeight:'800',whiteSpace:'nowrap'},
  secTitle:{fontSize:'17px',fontWeight:'900',color:T.dark,margin:'18px 16px 10px'},
  grid:{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'10px',padding:'0 16px',marginBottom:'16px'},
  card:{borderRadius:'20px',padding:'18px 14px',cursor:'pointer',border:'none',textAlign:'left',display:'flex',flexDirection:'column',gap:'6px',boxShadow:'0 6px 20px rgba(0,0,0,0.12)',position:'relative',overflow:'hidden'},
  cardIcon:{fontSize:'34px'},
  cardTitle:{fontSize:'15px',fontWeight:'900',margin:0},
  cardSub:{fontSize:'11px',margin:0,fontWeight:'600',opacity:0.8},
  lockBadge:{position:'absolute',top:'10px',right:'10px',background:'rgba(0,0,0,0.15)',borderRadius:'10px',padding:'3px 8px',fontSize:'11px',fontWeight:'700',color:'white'},
  comingSoon:{position:'absolute',bottom:0,left:0,right:0,background:'rgba(0,0,0,0.08)',textAlign:'center',padding:'4px',fontSize:'10px',fontWeight:'800',letterSpacing:'0.05em'},
  bottomNav:{position:'fixed',bottom:0,left:'50%',transform:'translateX(-50%)',width:'100%',maxWidth:'430px',background:'#0D1B4B',borderTop:'1px solid rgba(255,255,255,0.1)',display:'flex',justifyContent:'space-around',padding:'8px 0 10px',zIndex:100,boxShadow:'0 -4px 20px rgba(13,27,75,0.3)'},
  navItem:{display:'flex',flexDirection:'column',alignItems:'center',gap:'2px',cursor:'pointer',border:'none',background:'none',padding:'4px 10px'},
  backBtn:{background:'none',border:'none',fontSize:'15px',fontWeight:'800',color:'#0D1B4B',cursor:'pointer',padding:'14px 16px',display:'flex',alignItems:'center',gap:'6px'},
  mainCard:{background:'white',borderRadius:'20px',margin:'0 16px 14px',padding:'20px',boxShadow:'0 4px 16px rgba(13,27,75,0.08)'},
  qBox:{background:'#EEF2FF',borderRadius:'14px',padding:'14px',marginBottom:'14px',borderLeft:`4px solid ${T.navy}`},
  optBtn:{width:'100%',padding:'14px 16px',borderRadius:'14px',border:'2px solid #E8EEFF',background:'white',textAlign:'left',fontSize:'14px',fontWeight:'700',color:'#1A1A2E',cursor:'pointer',marginBottom:'10px',display:'flex',alignItems:'center',gap:'10px',transition:'all 0.15s ease'},
  optLetter:{width:'30px',height:'30px',borderRadius:'50%',background:'#EEF2FF',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'13px',fontWeight:'900',flexShrink:0,color:'#0D1B4B'},
  nextBtn:{width:'100%',padding:'16px',borderRadius:'16px',border:'none',background:'linear-gradient(135deg,#0D1B4B,#1A3A8F)',color:'white',fontSize:'16px',fontWeight:'900',cursor:'pointer',marginTop:'14px',boxShadow:'0 4px 16px rgba(13,27,75,0.35)'},
  loadScreen:{display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',minHeight:'100vh',background:T.gradHeader},
  inputField:{width:'100%',padding:'15px 16px',borderRadius:'14px',border:`2.5px solid #E0E0E0`,fontSize:'16px',fontFamily:"'Nunito',sans-serif",outline:'none',boxSizing:'border-box',marginBottom:'12px',fontWeight:'600'},
  authCard:{background:'white',borderRadius:'24px',margin:'20px',padding:'28px',boxShadow:'0 8px 32px rgba(13,27,75,0.15)'},
  levelBadge:{display:'inline-flex',alignItems:'center',gap:'4px',borderRadius:'20px',padding:'4px 12px',fontSize:'12px',fontWeight:'800'},
  xpChip:{background:T.yellow,color:T.dark,borderRadius:'20px',padding:'3px 10px',fontSize:'12px',fontWeight:'900',display:'inline-block'},
};

// ── SOUNDS ───────────────────────────────────────────────────
let _AC=null;
function _gac(){if(!_AC)_AC=new(window.AudioContext||window.webkitAudioContext)();return _AC;}
export function playSound(type){
  // Haptic feedback on mobile
  try{
    if(navigator.vibrate){
      if(type==='correct') navigator.vibrate([30,20,30]); // double tap feel
      else if(type==='wrong') navigator.vibrate([80]);     // single long buzz
      else if(type==='levelup') navigator.vibrate([40,30,40,30,80]); // celebration
      else if(type==='coin') navigator.vibrate([15]);
    }
  }catch(_){}
  try{
    const ctx=_gac();
    if(type==='correct'){
      [320,480,560,720,880].forEach((freq,i)=>{
        setTimeout(()=>{
          const o=ctx.createOscillator(),g=ctx.createGain();
          o.type='sine';o.frequency.value=freq;
          g.gain.setValueAtTime(0.22,ctx.currentTime);
          g.gain.exponentialRampToValueAtTime(0.001,ctx.currentTime+0.55);
          o.connect(g);g.connect(ctx.destination);
          o.start();o.stop(ctx.currentTime+0.55);
        },i*120);
      });
    }else if(type==='wrong'){
      [200,160].forEach((freq,i)=>{
        setTimeout(()=>{
          const o=ctx.createOscillator(),g=ctx.createGain();
          o.type='sawtooth';o.frequency.value=freq;
          g.gain.setValueAtTime(0.18,ctx.currentTime);
          g.gain.exponentialRampToValueAtTime(0.001,ctx.currentTime+0.3);
          o.connect(g);g.connect(ctx.destination);
          o.start();o.stop(ctx.currentTime+0.3);
        },i*160);
      });
    }else if(type==='coin'){
      [800,1000,1200,1500].forEach((f,i)=>{
        setTimeout(()=>{
          const osc=ctx.createOscillator(),gain=ctx.createGain();
          osc.type='sine';osc.frequency.value=f;
          gain.gain.setValueAtTime(0.18,ctx.currentTime);
          gain.gain.exponentialRampToValueAtTime(0.001,ctx.currentTime+0.12);
          osc.connect(gain);gain.connect(ctx.destination);
          osc.start();osc.stop(ctx.currentTime+0.12);
        },i*75);
      });
    }else if(type==='levelup'){
      [330,440,550,660,880,1100].forEach((f,i)=>{
        setTimeout(()=>{
          const osc=ctx.createOscillator(),gain=ctx.createGain();
          osc.type='triangle';osc.frequency.value=f;
          gain.gain.setValueAtTime(0.2,ctx.currentTime);
          gain.gain.exponentialRampToValueAtTime(0.001,ctx.currentTime+0.5);
          osc.connect(gain);gain.connect(ctx.destination);
          osc.start();osc.stop(ctx.currentTime+0.5);
        },i*100);
      });
    }else if(type==='flip'){
      const o=ctx.createOscillator(),g=ctx.createGain();
      o.type='sine';
      o.frequency.setValueAtTime(300,ctx.currentTime);
      o.frequency.exponentialRampToValueAtTime(800,ctx.currentTime+0.1);
      o.frequency.exponentialRampToValueAtTime(400,ctx.currentTime+0.2);
      g.gain.setValueAtTime(0.15,ctx.currentTime);
      g.gain.exponentialRampToValueAtTime(0.001,ctx.currentTime+0.22);
      o.connect(g);g.connect(ctx.destination);
      o.start();o.stop(ctx.currentTime+0.22);
    }else if(type==='spin'){
      const sr=ctx.sampleRate,dur=2.0;
      const buf=ctx.createBuffer(1,sr*dur,sr);
      const d=buf.getChannelData(0);
      for(let i=0;i<d.length;i++){const t=i/sr;const env=t<0.3?t/0.3:Math.exp(-(t-0.3)*1.2);d[i]=(Math.random()*2-1)*env*0.3;}
      const s=ctx.createBufferSource();s.buffer=buf;
      const f=ctx.createBiquadFilter();f.type='bandpass';f.Q.value=2;
      f.frequency.setValueAtTime(1800,ctx.currentTime);
      f.frequency.exponentialRampToValueAtTime(400,ctx.currentTime+2.0);
      const gn=ctx.createGain();gn.gain.value=0.6;
      s.connect(f);f.connect(gn);gn.connect(ctx.destination);s.start();
    }else if(type==='sparkle'){
      for(let i=0;i<6;i++){
        setTimeout(()=>{
          const o=ctx.createOscillator(),g=ctx.createGain();
          o.type='sine';o.frequency.value=1200+Math.random()*2000;
          g.gain.setValueAtTime(0.08,ctx.currentTime);
          g.gain.exponentialRampToValueAtTime(0.001,ctx.currentTime+0.1);
          o.connect(g);g.connect(ctx.destination);
          o.start();o.stop(ctx.currentTime+0.1);
        },i*55+Math.random()*30);
      }

    // ── PET SOUNDS ──────────────────────────────────────────
    }else if(type==='pet_happy'){
      // Cheerful ascending chime — cute boing!
      [523,659,784,1047].forEach((f,i)=>{
        setTimeout(()=>{
          const o=ctx.createOscillator(),g=ctx.createGain();
          o.type='sine'; o.frequency.setValueAtTime(f*0.8,ctx.currentTime);
          o.frequency.exponentialRampToValueAtTime(f,ctx.currentTime+0.06);
          g.gain.setValueAtTime(0.18,ctx.currentTime);
          g.gain.exponentialRampToValueAtTime(0.001,ctx.currentTime+0.25);
          o.connect(g);g.connect(ctx.destination);
          o.start();o.stop(ctx.currentTime+0.25);
        },i*90);
      });

    }else if(type==='pet_tap'){
      // Soft boing — rubbery bounce feel
      const o=ctx.createOscillator(),g=ctx.createGain();
      o.type='sine';
      o.frequency.setValueAtTime(520,ctx.currentTime);
      o.frequency.exponentialRampToValueAtTime(280,ctx.currentTime+0.18);
      g.gain.setValueAtTime(0.20,ctx.currentTime);
      g.gain.exponentialRampToValueAtTime(0.001,ctx.currentTime+0.22);
      o.connect(g);g.connect(ctx.destination);
      o.start();o.stop(ctx.currentTime+0.22);

    }else if(type==='pet_eat'){
      // Chomping munchy sound
      [400,350,420,380].forEach((f,i)=>{
        setTimeout(()=>{
          const o=ctx.createOscillator(),g=ctx.createGain();
          o.type='square'; o.frequency.value=f;
          g.gain.setValueAtTime(0.10,ctx.currentTime);
          g.gain.exponentialRampToValueAtTime(0.001,ctx.currentTime+0.08);
          o.connect(g);g.connect(ctx.destination);
          o.start();o.stop(ctx.currentTime+0.08);
        },i*100);
      });
      // Swallow sound after
      setTimeout(()=>{
        const o=ctx.createOscillator(),g=ctx.createGain();
        o.type='sine'; o.frequency.setValueAtTime(300,ctx.currentTime);
        o.frequency.exponentialRampToValueAtTime(150,ctx.currentTime+0.2);
        g.gain.setValueAtTime(0.12,ctx.currentTime);
        g.gain.exponentialRampToValueAtTime(0.001,ctx.currentTime+0.2);
        o.connect(g);g.connect(ctx.destination);
        o.start();o.stop(ctx.currentTime+0.2);
      },450);

    }else if(type==='pet_sad'){
      // Descending droopy notes
      [440,370,311,262].forEach((f,i)=>{
        setTimeout(()=>{
          const o=ctx.createOscillator(),g=ctx.createGain();
          o.type='triangle'; o.frequency.value=f;
          g.gain.setValueAtTime(0.14,ctx.currentTime);
          g.gain.exponentialRampToValueAtTime(0.001,ctx.currentTime+0.35);
          o.connect(g);g.connect(ctx.destination);
          o.start();o.stop(ctx.currentTime+0.35);
        },i*200);
      });

    }else if(type==='pet_evolve'){
      // Magical evolution fanfare — sweeping shimmer
      const dur=2.5;
      for(let i=0;i<20;i++){
        setTimeout(()=>{
          const o=ctx.createOscillator(),g=ctx.createGain();
          o.type='sine';
          const base=400+i*60;
          o.frequency.setValueAtTime(base,ctx.currentTime);
          o.frequency.exponentialRampToValueAtTime(base*2,ctx.currentTime+0.3);
          g.gain.setValueAtTime(0.10,ctx.currentTime);
          g.gain.exponentialRampToValueAtTime(0.001,ctx.currentTime+0.4);
          o.connect(g);g.connect(ctx.destination);
          o.start();o.stop(ctx.currentTime+0.4);
        },i*100);
      }

    }else if(type==='pet_sleep'){
      // Gentle Zzz hum
      const o=ctx.createOscillator(),g=ctx.createGain();
      o.type='sine'; o.frequency.value=160;
      g.gain.setValueAtTime(0.06,ctx.currentTime);
      g.gain.linearRampToValueAtTime(0.10,ctx.currentTime+0.5);
      g.gain.linearRampToValueAtTime(0,ctx.currentTime+1.5);
      o.connect(g);g.connect(ctx.destination);
      o.start();o.stop(ctx.currentTime+1.5);

    }else if(type==='pet_play'){
      // Bouncy playful notes — like a toy
      [523,659,523,784,659,880].forEach((f,i)=>{
        setTimeout(()=>{
          const o=ctx.createOscillator(),g=ctx.createGain();
          o.type='triangle'; o.frequency.value=f;
          g.gain.setValueAtTime(0.14,ctx.currentTime);
          g.gain.exponentialRampToValueAtTime(0.001,ctx.currentTime+0.12);
          o.connect(g);g.connect(ctx.destination);
          o.start();o.stop(ctx.currentTime+0.12);
        },i*110);
      });

    }else if(type==='pet_buy'){
      // Cash register / purchase chime
      [800,1000,1300,1600,2000].forEach((f,i)=>{
        setTimeout(()=>{
          const o=ctx.createOscillator(),g=ctx.createGain();
          o.type='sine'; o.frequency.value=f;
          g.gain.setValueAtTime(0.15,ctx.currentTime);
          g.gain.exponentialRampToValueAtTime(0.001,ctx.currentTime+0.15);
          o.connect(g);g.connect(ctx.destination);
          o.start();o.stop(ctx.currentTime+0.15);
        },i*70);
      });

    }else if(type==='pet_card'){
      // Magical card drop sparkle
      for(let i=0;i<8;i++){
        setTimeout(()=>{
          const o=ctx.createOscillator(),g=ctx.createGain();
          o.type='sine'; o.frequency.value=800+i*200+Math.random()*100;
          g.gain.setValueAtTime(0.12,ctx.currentTime);
          g.gain.exponentialRampToValueAtTime(0.001,ctx.currentTime+0.18);
          o.connect(g);g.connect(ctx.destination);
          o.start();o.stop(ctx.currentTime+0.18);
        },i*65);
      }
      // Final shimmer
      setTimeout(()=>{
        [2000,2400,2800].forEach((f,i)=>{
          setTimeout(()=>{
            const o=ctx.createOscillator(),g=ctx.createGain();
            o.type='sine'; o.frequency.value=f;
            g.gain.setValueAtTime(0.08,ctx.currentTime);
            g.gain.exponentialRampToValueAtTime(0.001,ctx.currentTime+0.2);
            o.connect(g);g.connect(ctx.destination);
            o.start();o.stop(ctx.currentTime+0.2);
          },i*80);
        });
      },520);
    }
  }catch(e){}
}

// ── CONFETTI ─────────────────────────────────────────────────
export function fireConfetti(){
  confetti({particleCount:150,spread:90,origin:{y:0.55},
    colors:['#0066FF','#FF6B00','#00C851','#8B2BE2','#FFD600','#FF4081']});
}
export function fireMini(){
  confetti({particleCount:50,spread:60,origin:{y:0.7},
    colors:['#00C851','#FFD600','#FF6B00']});
}

// ── LOADING SPINNER ──────────────────────────────────────────
export function LoadingSpinner({text=''}){
  const petType = typeof localStorage!=='undefined' ? (localStorage.getItem('ns_pet_type')||'lumie') : 'lumie';
  const petEmoji = petType==='cosmo'?'🤖':petType==='nova'?'🌙':'⭐';
  const petColor = petType==='cosmo'?'#00BCD4':petType==='nova'?'#9C27B0':'#FFD600';
  return(
    <div style={{...S.loadScreen,background:'linear-gradient(160deg,#0A0E27 0%,#1A0533 50%,#0D1B4B 100%)'}}>
      <motion.div style={{fontSize:'72px',marginBottom:'16px',lineHeight:1}}
        animate={{y:[0,-12,0],scale:[1,1.08,1]}}
        transition={{repeat:Infinity,duration:2,ease:'easeInOut'}}>{petEmoji}</motion.div>
      <p style={{fontSize:'16px',fontWeight:'800',color:'rgba(255,255,255,0.7)',margin:0,fontFamily:"'Nunito',sans-serif"}}>
        {text||'Loading...'}
      </p>
      <div style={{width:100,height:3,background:'rgba(255,255,255,0.1)',borderRadius:4,marginTop:16,overflow:'hidden'}}>
        <motion.div
          animate={{x:['-100%','100%']}}
          transition={{repeat:Infinity,duration:1.2,ease:'easeInOut'}}
          style={{width:'60%',height:'100%',background:`linear-gradient(90deg,transparent,${petColor},transparent)`,borderRadius:4}}/>
      </div>
    </div>
  );
}

// ── CHARACTER POOL ───────────────────────────────────────────
export const CHAR_POOL=['Arjun','Kavya','Rohan','Meera','Priya','Vivek','Anaya','Kabir','Tara','Neha','Dev','Riya','Sana','Ishan','Leela','Dhruv','Pooja','Rahul','Sneha','Kiran'];
export function getChar(idx){return CHAR_POOL[idx%CHAR_POOL.length];}
export function CharacterChip({idx}){
  const name=getChar(idx);
  return(
    <div style={{display:'inline-flex',alignItems:'center',gap:'5px',
      background:'#FFF8E1',borderRadius:'20px',padding:'4px 12px',
      marginBottom:'10px',border:'1.5px solid #FFE082'}}>
      <span style={{fontSize:'13px'}}>👤</span>
      <span style={{fontSize:'12px',fontWeight:'900',color:'#E65100'}}>{name} asks:</span>
    </div>
  );
}

// ── REFERRAL HELPERS ─────────────────────────────────────────
export function makeReferralCode(email){
  try{return btoa(email).replace(/=/g,'');}catch{return '';}
}
export function decodeReferralCode(code){
  try{const pad=code.length%4;const padded=pad?code+'='.repeat(4-pad):code;return atob(padded);}catch{return null;}
}
export function getReferralFromUrl(){
  try{const p=new URLSearchParams(window.location.search);return p.get('ref')||null;}catch{return null;}
}

// ── AUTH STARS (pre-computed, stable across re-renders) ──────
export const AUTH_STARS=(()=>{
  const icons=['⭐','✨','💫','🌟'];
  return Array.from({length:20},()=>({
    left:`${Math.random()*100}%`,
    top:`${Math.random()*60}%`,
    size:`${Math.random()*16+8}px`,
    duration:Math.random()*3+2,
    delay:Math.random()*3,
    icon:icons[Math.floor(Math.random()*4)],
  }));
})();

// ── TOAST ─────────────────────────────────────────────────────
let _toastFn=null;
export function registerToast(fn){_toastFn=fn;}
export function showToast(msg,type='success'){if(_toastFn)_toastFn(msg,type);}

export function ToastProvider(){
  const [toasts,setToasts]=React.useState([]);
  React.useEffect(()=>{
    registerToast((msg,type)=>{
      const id=Date.now();
      setToasts(t=>[...t,{id,msg,type}]);
      setTimeout(()=>setToasts(t=>t.filter(x=>x.id!==id)),3000);
    });
  },[]);
  const bg={success:'#1A1A2E',error:'#D32F2F',info:'#0066FF'};
  const icon={success:'✅',error:'❌',info:'ℹ️'};
  return(
    <div style={{position:'fixed',top:16,left:'50%',transform:'translateX(-50%)',zIndex:99999,display:'flex',flexDirection:'column',gap:8,alignItems:'center',pointerEvents:'none',width:'90%',maxWidth:380}}>
      {toasts.map(t=>(
        <motion.div key={t.id} initial={{opacity:0,y:-20}} animate={{opacity:1,y:0}} exit={{opacity:0}}
          style={{background:bg[t.type]||bg.success,color:'white',borderRadius:14,padding:'12px 18px',
            fontSize:14,fontWeight:800,fontFamily:"'Nunito',sans-serif",boxShadow:'0 4px 20px rgba(0,0,0,0.25)',
            display:'flex',alignItems:'center',gap:10,width:'100%'}}>
          <span style={{fontSize:18}}>{icon[t.type]||icon.success}</span>
          <span>{t.msg}</span>
        </motion.div>
      ))}
    </div>
  );
}

// ── DAILY CHALLENGES ─────────────────────────────────────────
export const DAILY_CHALLENGES=[
  {day:0,icon:'🔬',title:'Science Sunday',desc:'Complete any Science World lab today!',screen:'science',color:'#00BCD4',bonus:'+20 Bonus XP'},
  {day:1,icon:'➗',title:'Maths Monday',desc:'Beat Maths Ninja on Medium level!',screen:'maths',color:'#FF6B00',bonus:'+20 Bonus XP'},
  {day:2,icon:'🏆',title:'Olympiad Tuesday',desc:'Answer 10 Olympiad questions today!',screen:'olympiad',color:'#8B2BE2',bonus:'+25 Bonus XP'},
  {day:3,icon:'💰',title:'Money Wednesday',desc:'Complete a Money School world!',screen:'money',color:'#00C851',bonus:'+20 Bonus XP'},
  {day:4,icon:'🎮',title:'Game Thursday',desc:'Play Quick Maths or Word Scramble!',screen:'games',color:'#FF2D55',bonus:'+15 Bonus XP'},
  {day:5,icon:'🏪',title:'Biz World Friday',desc:'Build your Chai Stall empire today!',screen:'entrepreneurship',color:'#FF6B00',bonus:'+25 Bonus XP'},
  {day:6,icon:'🎙️',title:'Quiz Bot Saturday',desc:'Answer 10 Quiz Bot questions!',screen:'quiz_bot',color:'#0066FF',bonus:'+20 Bonus XP'},
];
